module.exports = __webpack_public_path__ + "media/components/wind-icon/static/SSE@2x-0d21334757623054c248d0ab2e0744c1.png";